import { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import config from '../config';
import { useNavigate } from "react-router-dom";
import { RequerimientoModalConfirmar } from './RequerimientoModalConfirmar';

export function RequerimientoModalForm({ onClose, dataLogin, modoEdicion = false, requerimiento = null, visitas = [], setSecondModalOpen, setSecondModalContent }) {
  const [mostrarTablaVT, setMostrarTablaVT] = useState(true);
  const [clientes, setClientes] = useState([]);
  const [clienteSelected, setClienteSelected] = useState(null);
  const [obras, setObras] = useState([]);
  const [obraSelected, setObraSelected] = useState('');
  const [contactos, setContactos] = useState([]);
  const [mostrarBotonVT, setMostrarBotonVT] = useState(true);

  const navigate = useNavigate();
  const today = new Date();

  const clienteCargadoRef = useRef(false);
  const obraPrecargadaRef = useRef(false);
  const precargaHechaRef = useRef(false);

  const handleRadioChange = (event) => {
    setMostrarTablaVT(event.target.value === "1");

    setMostrarBotonVT(!mostrarBotonVT);

    const nuevaFila = { ...filaPredeterminada, id: 1 };
    setFilas([nuevaFila]);

    setFormRequerimientoData({
      ...formRequerimientoData,
      ["requiere_visita_tecnica"]: event.target.value,
    });
  }

  const obtenerClientes = async () => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/cliente.php`
      );
      const data = await response.json();

      if (data && data[0].id_cliente) {
        setClientes(data);
      }
    } catch (error) {
      setClientes([]);
    }
  };

  useEffect(() => {
    if (dataLogin?.id_usuario) {
      obtenerClientes(dataLogin.id_usuario);
    }
  }, [dataLogin]);

  useEffect(() => {
    if (modoEdicion && requerimiento && !precargaHechaRef.current) {
      precargaHechaRef.current = true;

      setClienteSelected({ label: requerimiento.nombre_cliente, value: requerimiento.id_cliente });

      setFormRequerimientoData({
        id_cliente: requerimiento.id_cliente,
        id_obra: requerimiento.id_obra,
        id_contacto: requerimiento.id_contacto,
        fecha_requerimiento: convertirFechaParaInput(requerimiento.fecha_requerimiento),
        nombre_requerimiento: requerimiento.nombre_requerimiento,
        detalle: requerimiento.detalle
      });

      if (Array.isArray(visitas)) {
        setFilas([]);
      }
    }
  }, [modoEdicion, requerimiento]);

  useEffect(() => {
    if (clienteSelected?.value && !clienteCargadoRef.current) {
      clienteCargadoRef.current = true;

      obtenerObras(clienteSelected.value);
      obtenerContactos(clienteSelected.value);
    }
  }, [clienteSelected]);

  useEffect(() => {
    if (modoEdicion && requerimiento && obras.length > 0 && !obraPrecargadaRef.current) {
      obraPrecargadaRef.current = true;
      setObraSelected(requerimiento.id_obra);
    }
  }, [modoEdicion, requerimiento, obras]);

  const handleClienteSelect = async (selectedOption) => {
    clienteCargadoRef.current = false;
    setClienteSelected(selectedOption);

    setFormRequerimientoData(prev => ({
      ...prev,
      id_cliente: selectedOption.value.toString(),
    }));
  };
  useEffect(() => {
    if (
      modoEdicion &&
      requerimiento &&
      obras.length > 0 &&
      contactos.length > 0 &&
      !obraPrecargadaRef.current
    ) {
      obraPrecargadaRef.current = true;

      setObraSelected({ label: requerimiento.nombre_obra, value: requerimiento.id_obra });

      setFormRequerimientoData(prev => ({
        ...prev,
        id_obra: requerimiento.id_obra.toString(),
        id_contacto: requerimiento.id_contacto.toString(),
      }));
    }
  }, [modoEdicion, requerimiento, obras, contactos]);

  const handleObraSelect = (e) => {
    const id = Number(e.target.value); // o sin Number si tus IDs son strings
    const selected = obras.find((obra) => obra.id_obra === id);

    setFormRequerimientoData((prev) => ({
      ...prev,
      id_obra: id,
    }));

    setObraSelected(selected); // guarda el objeto completo para usar su nombre después
  };

  const obtenerObras = async (cliente) => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/cliente_obra.php?id_cliente=${cliente}`
      );
      const data = await response.json();

      if (data && data[0].id_obra) {
        setObras(data);
      }
    } catch (error) {
      setObras([]);
    }
  };

  const obtenerContactos = async (cliente) => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/contacto_2.php/?id_cliente=${cliente}`
      );
      const data = await response.json();

      if (data && data[0].id_contacto) {
        setContactos(data);
      }
    } catch (error) {
      setContactos([]);
    }
  };

  const optionsClientes = clientes.map((cliente) => ({
    value: cliente.id_cliente,
    label: cliente.nombre_cliente,
  }));

  const filaPredeterminada = {
    id: 1,
    id_requerimiento: '',
    fecha: '',
    texto: '',
    id_usuario: dataLogin.id_usuario.toString()
  };
  const [filas, setFilas] = useState([]);

  const filaPredeterminadaImagenes = {
    id: 1,
    id_visita: '',
    id_requerimiento: '',
    imagen: '',
    id_usuario: dataLogin.id_usuario.toString()
  };
  const [filasImagenes, setFilasImagenes] = useState([filaPredeterminadaImagenes]);

  const handleAgregarFila = () => {
    const nuevaFila = {
      id: filas.length + 1,
      id_requerimiento: '',
      fecha: '',
      texto: '',
      id_usuario: dataLogin.id_usuario.toString()
    };

    setFilas([...filas, nuevaFila]);

    const nuevaFilaImagenes = {
      id: filasImagenes.length + 1,
      id_visita: '',
      id_requerimiento: '',
      imagen: '',
      id_usuario: dataLogin.id_usuario.toString()
    };

    setFilasImagenes([...filasImagenes, nuevaFilaImagenes]);
  };

  const handleInputChange = (id, campo, valor) => {
    if (!Array.isArray(filas)) return;
    const nuevasFilas = filas.map((fila) =>
      fila.id === id ? { ...fila, [campo]: valor } : fila
    );

    setFilas(nuevasFilas);
  };

  const [base64Strings, setBase64Strings] = useState([]);
  const handleFileChange = async (event, id) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result;
      if (!Array.isArray(filas)) return;
      const nuevasFilas = filas.map((fila) =>
        fila.id === id ? { ...fila, imagen: base64 } : fila
      );

      setFilas(nuevasFilas);
    };

    reader.readAsDataURL(file);
  };

  const handleEliminarFila = (id) => {
    // Verificar que haya más de una fila antes de eliminar
    if (filas.length > 1) {
      const nuevasFilas = filas.filter((fila) => fila.id !== id);
      setFilas(nuevasFilas);
    } else {
      alert("Debe agregar al menos una visita técnica, de lo contrario seleccione 'No'.");
    }
  };

  const [formRequerimientoData, setFormRequerimientoData] = useState({
    id_cliente: "",
    id_obra: "",
    id_contacto: "",
    fecha_requerimiento: "",
    nombre_requerimiento: "",
    detalle: "",
    requiere_visita_tecnica: "1",
    id_usuario: dataLogin.id_usuario.toString()
  });

  const handleFormRequerimientoData = (e) => {
    const { name, value } = e.target;
    setFormRequerimientoData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmitRequerimiento = async (event) => {
    event.preventDefault();

    try {
      const esFormularioValido = validaFormularioRequerimiento();

      if (!esFormularioValido) return;

      const payload = {
        ...formRequerimientoData,
        fecha_requerimiento: formRequerimientoData.fecha_requerimiento
      };

      const contactoSeleccionado = contactos.find(
        c => String(c.id_contacto) === String(formRequerimientoData.id_contacto)
      );

      const urlRequerimiento = modoEdicion
        ? `${config.apiBaseUrl}/requerimiento.php?id=${requerimiento.id_requerimiento}`
        : `${config.apiBaseUrl}/requerimiento.php`;

      const metodoRequerimiento = modoEdicion ? "PUT" : "POST";

      const responseRequerimiento = await fetch(urlRequerimiento, {
        method: metodoRequerimiento,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const dataRequerimiento = await responseRequerimiento.json();

      const mensajeEsperado = modoEdicion
        ? "Requerimiento modificado con éxito."
        : "Requerimiento agregado con éxito.";

      if (dataRequerimiento.message === mensajeEsperado) {
        const nuevoRequerimiento = {
          ...formRequerimientoData,
          id_requerimiento: modoEdicion ? requerimiento.id_requerimiento : dataRequerimiento.id_requerimiento,
          email_solicitante: contactoSeleccionado?.email || contactoSeleccionado.email,
          nombre_obra: requerimiento?.nombre_obra || obraSelected.label,
          nombre_cliente: requerimiento?.nombre_cliente || clienteSelected.label,
          nombre_contacto: requerimiento?.nombre_contacto || contactoSeleccionado.nombres + ' ' + contactoSeleccionado.apellido_paterno,
        };

        const id_requerimiento = modoEdicion ? requerimiento.id_requerimiento : dataRequerimiento.id_requerimiento;

        const hayVisitas = filas.length > 0;
        const hayImagenes = filasImagenes.some(obj => obj.imagenes?.length > 0);

        if (hayVisitas || hayImagenes) {
          if (!Array.isArray(filas)) return;
          const filasModificadas = filas.map(objeto => ({
            ...objeto,
            id_requerimiento
          }));

          const responseVisitasTecnicas = await fetch(
            `${config.apiBaseUrl}/visita_tecnica.php`,
            {
              method: 'POST',//metodoRequerimiento,
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(filasModificadas),
            }
          );

          const dataVisitasTecnicas = await responseVisitasTecnicas.json();
          if (dataVisitasTecnicas.message === "Visita técnica agregada con éxito.") {
            if (!Array.isArray(filas)) return;

            const filasMapeadas = filas.map((objeto, index) => ({
              ...objeto,
              id_visita: dataVisitasTecnicas.ids_visitas[index],
              id_requerimiento
            }));

            const imagenesValidas = filasMapeadas.filter(obj =>
              obj.id_visita && obj.imagen && obj.imagen.length > 0
            );

            const responseVisitasTecnicasImagenes = await fetch(`${config.apiBaseUrl}/imagenes.php`,
              {
                method: 'POST',//metodoRequerimiento,
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', },
                body: JSON.stringify(imagenesValidas),
              }
            );

            const dataVisitasTecnicasImagenes = await responseVisitasTecnicasImagenes.json();
            if (dataVisitasTecnicasImagenes.message === "Imagenes de visita técnica agregadas con éxito.") {
              limpiarFormulario();
            }
          }
        } else {
          limpiarFormulario();
        }

        setSecondModalContent(
          <RequerimientoModalConfirmar
            requerimiento={nuevoRequerimiento}
            onClose={() => setSecondModalOpen(false)}
          />
        );
        setSecondModalOpen(true);

        alert(mensajeEsperado);
        onClose();
        navigate("/dashboard", { state: dataLogin });
      }
    } catch (error) {
      console.info(error)
      alert(`Error al ${modoEdicion ? 'actualizar' : 'agregar'} el requerimiento`);
    }
  };

  const limpiarFormulario = () => {
    setFormRequerimientoData({
      id_requerimiento: "",
      id_cliente: "",
      id_obra: "",
      id_contacto: "",
      fecha_requerimiento: "",
      nombre_requerimiento: "",
      detalle: "",
      requiere_visita_tecnica: "1",
      id_usuario: dataLogin.id_usuario.toString()
    });

    setFilas([filaPredeterminada]);
    setFilasImagenes(filaPredeterminadaImagenes);
    setBase64Strings(0);
  };

  const validaFormularioRequerimiento = () => {
    if (mostrarTablaVT) {
      if (!Array.isArray(filas)) return;
      const valido = filas.map((fila) => {
        if (fila.fecha === "" || fila.texto === "") {
          //alert(`La fila con id ${fila.id} tiene campos vacíos`);
          alert("Debe ingresar la fecha y detalle de las visitas técnicas");
          return false;
        }
        return true;
      }).every(v => v);

      if (!valido) {
        return false;
      }
    }

    if (formRequerimientoData.id_cliente === "") {
      alert('Debe seleccionar un cliente');
      return false;
    }

    if (formRequerimientoData.id_obra === "") {
      alert('Debe seleccionar una obra');
      return false;
    }

    if (formRequerimientoData.fecha_requerimiento === "") {
      alert('Debe indicar la fecha del requerimiento');
      return false;
    }

    if (formRequerimientoData.detalle === "") {
      alert('Debe ingresar el detalle del requerimiento');
      return false;
    }

    return true;
  }

  const convertirFechaParaInput = (fecha) => {
    const [dia, mes, anio] = fecha.split("-");
    return `${anio}-${mes}-${dia}`; // YYYY-MM-DD
  };

  return (
    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="mb-0">
            {modoEdicion ? 'Editar Requerimiento' : 'Agregar Requerimiento'}
          </h4>
          <button onClick={onClose} className="btn-close"></button>
        </div>
        <div className="modal-body py-3 px-5">
          <div className="row row-cols-1 row-cols-md-2 g-4 mb-3">
            {clientes ? (
              <div className="col">
                <label className="form-label">Cliente</label>
                <Select
                  name="id_cliente"
                  value={clienteSelected}
                  onChange={handleClienteSelect}
                  options={optionsClientes}
                  isSearchable
                  className="react-select"
                  placeholder="Seleccione un cliente"
                />
              </div>
            ) : (
              <div className="col">
                <label className="form-label">Cliente</label>
                <select className="form-select" name="cliente_req">
                  <option value="">No se encontraron clientes</option>
                </select>
              </div>
            )}
            {obras ? (
              <div className="col">
                <label className="form-label">Obra</label>
                <select
                  className="form-select"
                  name="id_obra"
                  value={formRequerimientoData.id_obra}
                  onChange={handleObraSelect}
                >
                  <option value="">Seleccione una obra</option>
                  {obras.map((obra) => (
                    <option key={obra.id_obra} value={obra.id_obra}>{obra.nombre}</option>
                  ))}
                </select>
              </div>
            ) : (
              <div className="col">
                <label className="form-label">Obra</label>
                <select className="form-select" name="obra_req">
                  <option value="">Cliente sin obras asociadas</option>
                </select>
              </div>
            )}
          </div>
          <div className="row row-cols-1 row-cols-md-2 g-4 mb-3">
            <div className="col">
              <label className="form-label">Solicitante (Contacto)</label>
              {contactos ? (
                <select className="form-select" name="id_contacto" value={formRequerimientoData.id_contacto} onChange={handleFormRequerimientoData}>
                  <option value="">Seleccione Solicitante</option>
                  {contactos.map((contacto) => (
                    <option key={contacto.id_contacto} value={contacto.id_contacto}>{contacto.nombres + " " + contacto.apellido_paterno + " " + contacto.apellido_materno}</option>
                  ))}
                </select>
              ) : (
                <select className="form-select" name="id_contacto">
                  <option value="">Cliente sin contactos asociados</option>
                </select>
              )}
            </div>
            <div className="col">
              <label className="form-label">Fecha Requerimiento</label>
              <input
                className="form-control"
                type="date"
                name="fecha_requerimiento"
                value={formRequerimientoData.fecha_requerimiento}
                max={today.toISOString().split('T')[0]}
                onChange={handleFormRequerimientoData}
              />
            </div>
          </div>
          <div className="mb-3">
            <label className="form-label">Nombre Requerimiento</label>
            <input
              className="form-control"
              type="text"
              name="nombre_requerimiento"
              value={formRequerimientoData.nombre_requerimiento}
              onChange={handleFormRequerimientoData}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Detalle Requerimiento</label>
            <textarea
              className="form-control"
              name="detalle"
              type="textarea"
              rows="2"
              value={formRequerimientoData.detalle}
              onChange={handleFormRequerimientoData}
            />
          </div>
          <label className="form-label d-block">¿Requiere visita técnica?</label>
          <div className="d-flex justify-content-md-between">
            <div>
              <input
                type="radio"
                className="btn-check"
                name="visita_tecnica_req"
                id="visita-tecnica-si-req"
                autoComplete="off"
                value="1"
                checked={mostrarTablaVT}
                onChange={handleRadioChange}
              />
              <label className="btn" htmlFor="visita-tecnica-si-req">Si</label>
              <input
                type="radio"
                className="btn-check"
                name="visita_tecnica_req"
                id="visita-tecnica-no-req"
                autoComplete="off"
                value="0"
                checked={!mostrarTablaVT}
                onChange={handleRadioChange}
              />
              <label className="btn" htmlFor="visita-tecnica-no-req">No</label>
            </div>
            {mostrarBotonVT && (
              <button type="button" className="btn btn-outline-dark btn-sm" onClick={handleAgregarFila}>
                <i className="bi-plus-circle"></i> Agregar
              </button>
            )}
          </div>
          {mostrarTablaVT && (
            <div className="table-responsive border rounded mt-3">
              <table className="table mb-0">
                <thead>
                  <tr className="table-active border-bottom">
                    <th className="col-2">Fecha</th>
                    <th className="col-5">Detalle</th>
                    <th className="col-4">Documento</th>
                    <th className="col-1"></th>
                  </tr>
                </thead>
                <tbody>
                  {(filas ?? []).map((fila) => (
                    <tr key={fila.id}>
                      <td className="col-2">
                        <input
                          className="form-control form-control-sm"
                          type="date"
                          value={fila.fecha}
                          onChange={(e) =>
                            handleInputChange(fila.id, 'fecha', e.target.value)
                          }
                        />
                      </td>
                      <td className="col-5">
                        <input
                          className="form-control form-control-sm"
                          type="text"
                          value={fila.texto}
                          onChange={(e) =>
                            handleInputChange(fila.id, 'texto', e.target.value)
                          }
                        />
                      </td>
                      <td className="col-4">
                        <input
                          className="form-control form-control-sm"
                          type="file"
                          multiple
                          onChange={(e) =>
                            handleFileChange(e, fila.id)
                          }
                        />
                      </td>
                      <td className="col-1">
                        <button className="btn btn-outline-danger btn-sm" onClick={() => handleEliminarFila(fila.id)}>
                          <i className="bi bi-trash3"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className="modal-footer flex-row">
          <button className="btn btn-yellow" onClick={handleSubmitRequerimiento}>
            <i className="bi bi-floppy"></i> {modoEdicion ? 'Actualizar' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}
